'use client'

import ScrollToTop from '@/components/ScrollToTop'
import ViverseSkeleton from '@/components/ViverseSkeleton'
import { useLayoutContext } from '@/context/LayoutContext'

export default function PartnerPageSkeleton() {
  const { headerHeight } = useLayoutContext()

  return (
    <main className="relative flex min-h-screen flex-1 flex-col overflow-hidden">
      <ScrollToTop />

      {/* HeroSection: left text + right calculator */}
      <section
        className="relative flex flex-1 flex-col items-center justify-center"
        style={{ marginTop: headerHeight + 40 }}
      >
        <div className="1.5xl:gap-[122px] flex w-full max-w-[1296px] flex-col gap-6 lg:flex-row lg:items-center">
          {/* Left: title (3 lines) + description + CTA */}
          <div className="flex flex-1 flex-col items-center gap-6 lg:items-start">
            <div className="flex flex-col items-center gap-2 lg:items-start">
              <ViverseSkeleton className="h-10 w-3/4 rounded-lg md:h-14" />
              <ViverseSkeleton className="h-10 w-full rounded-lg md:h-14" />
              <ViverseSkeleton className="h-10 w-2/3 rounded-lg md:h-14" />
            </div>
            <ViverseSkeleton className="h-4 w-full max-w-md rounded-lg" />
            <ViverseSkeleton className="h-4 w-4/5 max-w-md rounded-lg" />
            <ViverseSkeleton className="h-12 w-44 rounded-xl" />
          </div>
          {/* Right: calculator box */}
          <ViverseSkeleton className="min-h-[471px] w-full rounded-2xl lg:max-w-[480px]" />
        </div>
        {/* TrustStrip: full-width scrolling strip */}
        <div className="mt-6 w-full border-t border-b border-[rgba(213,226,242,0.08)] py-[18px]">
          <div className="flex gap-8 overflow-hidden">
            {Array.from({ length: 5 }).map((_, i) => (
              <ViverseSkeleton key={i} className="h-5 w-48 shrink-0 rounded-md" />
            ))}
          </div>
        </div>
      </section>
    </main>
  )
}
